import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { TrustBar } from "./components/TrustBar";
import { Problem } from "./components/Problem";
import { Services } from "./components/Services";
import { Audiences } from "./components/Audiences";
import { AIAdvantage } from "./components/AIAdvantage";
import { Engagement } from "./components/Engagement";
import { About } from "./components/About";
import { Proof } from "./components/Proof";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import { ContactModal } from "./components/ContactModal";
import { PrivacyPolicy, TermsOfService, usePageMeta } from "./pages/Legal";

const Home = ({ onConsult }) => {
  usePageMeta(
    "Cogniti.ai CFO | Fractional CFO & Finance Shared Services India",
    "Cogniti.ai CFO provides Fractional CFO, Finance Shared Services, Controllership, FP&A, GCC Finance, Compliance and Finance Transformation services in India and globally.",
    "/"
  );
  return (
    <main>
      <Hero onConsult={onConsult} />
      <TrustBar />
      <Problem />
      <Services />
      <Audiences />
      <AIAdvantage />
      <Engagement onConsult={onConsult} />
      <About />
      <Proof />
      <FinalCTA onConsult={onConsult} />
    </main>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const [consultOpen, setConsultOpen] = useState(false);
  const openConsult = () => setConsultOpen(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const hash = anchor.getAttribute("href");
      if (!hash || hash.length <= 1) return;
      const target = document.querySelector(hash);
      e.preventDefault();
      if (target) {
        lenis.scrollTo(hash, { offset: -72 });
      } else {
        window.location.href = `/${hash}`;
      }
    };
    document.addEventListener("click", onClick);

    if (window.location.hash) {
      setTimeout(() => {
        const el = document.querySelector(window.location.hash);
        if (el) lenis.scrollTo(el, { offset: -72 });
      }, 700);
    }

    return () => {
      document.removeEventListener("click", onClick);
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="App min-h-screen bg-white overflow-x-clip">
        <div className="noise-overlay" aria-hidden="true" />
        <ScrollToTop />
        <Header onConsult={openConsult} />
        <Routes>
          <Route path="/" element={<Home onConsult={openConsult} />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
        <Footer />
        <ContactModal open={consultOpen} onOpenChange={setConsultOpen} />
      </div>
    </BrowserRouter>
  );
}

export default App;
